module.exports = __webpack_public_path__ + "img/m_ic_menu.2a65b332.svg";